// extracted by mini-css-extract-plugin
module.exports = {"currencyBox":"CurrencyComponent_currencyBox__1Red1","container":"CurrencyComponent_container__1Oost"};